export default (params) => {
  const checklistType =
    !params.data &&
    params.node.childrenAfterGroup &&
    params.node.childrenAfterGroup.length > 0
      ? params.node.childrenAfterGroup[0].data['checklistType']
      : null;
  const propertyName =
    !params.data &&
    params.node.childrenAfterGroup &&
    params.node.childrenAfterGroup.length > 0
      ? params.node.childrenAfterGroup[0].data['propertyName']
      : null;

  return checklistType && checklistType.toLowerCase() === 'psq'
    ? propertyName
    : checklistType && checklistType.toLowerCase() === 'arqc' && 'N/A';
};
